import { ToggleGroup, ToggleGroupItem } from "../ui/toggle-group";

/** Single selection with Base UI keyboard navigation and pressed state. */
export function CatalogueFilters<T extends string>({
  label,
  options,
  value,
  onChange,
}: {
  readonly label: string;
  readonly options: ReadonlyArray<{ readonly id: T; readonly label: string }>;
  readonly value: T;
  readonly onChange: (value: T) => void;
}) {
  return (
    <ToggleGroup
      aria-label={label}
      size="sm"
      className="flex-wrap gap-1"
      value={[value]}
      onValueChange={(values) => {
        const option = options.find((item) => item.id === values[0]);
        if (option) onChange(option.id);
      }}
    >
      {options.map((option) => (
        <ToggleGroupItem key={option.id} value={option.id} className="px-3 text-muted-foreground">
          {option.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
